import { IAirline } from '@move-frontend/dap';
import styled from '@emotion/styled';
import { Css } from '../../../../../ui';

interface IAirlineCellProps {
	icaoOperatingAirline: string;
	airlineDetails?: IAirline;
}

export function AirlineCell({
	icaoOperatingAirline,
	airlineDetails,
}: IAirlineCellProps) {
	const logoSrc = airlineDetails?.squareLogo;
	const name = airlineDetails?.name || icaoOperatingAirline;

	return (
		<StyledAirlineCell>
			{logoSrc && (
				<img
					src={logoSrc}
					alt={`${name} logo`}
					width={25}
					height={25}
					loading="lazy"
				/>
			)}

			<div>{name}</div>
		</StyledAirlineCell>
	);
}

const StyledAirlineCell = styled.div`
	display: flex;
	gap: ${Css.pxToRem(16)};
`;
